// router/index.js (updated version)

import { createRouter, createWebHistory } from "vue-router";
import Cookies from "js-cookie";
import Login from "../views/LoginView.vue";
import i18n from "@/i18n";
import store from "@/store";

import classRoutes from "./routes/classRouter";
import groupRoutes from "./routes/groupRouter";
import studentRoutes from "./routes/studentRouter";
import userRouter from "./routes/userRouter";
import teacherRouter from "./routes/teacherRouter";
import guardianRouter from "./routes/guardianRouter";
import subjectRouter from "./routes/subjectRouter";
import chapterRouter from "./routes/chapterRouter";
import chapterSubjectRouter from "./routes/chapterSubjectRouter";
import assignmentsRouter from "./routes/assignmentsRouter";
import questions from "./routes/questions";
import announcement from "./routes/announcement";
import gradeSheetRouter from "./routes/gradeSheetRouter";
import paymentRouter from "./routes/paymentRouter";
import financialSettings from "./routes/financial-settings";
import reportsRouter from "./routes/reportsRouter";
import canteen from "./routes/canteen";
import examTypes from "./routes/exam-types";
import nationalities from "./routes/nationalities";
import busesRoutes from "./routes/buses";
import areasRoutes from "./routes/areas";
import salaryRoutes from "./routes/salary";
import postsRoutes from "./routes/posts";
import promotionRoutes from "./routes/promotion";
import studentRewardsRoutes from "./routes/student-rewards";
import tenantsRoutes from "./routes/tenants";
import employeeRouter from "./routes/employeeRouter";
import jobTitleRouter from "./routes/jobTitleRouter";
import teacherLessonRouter from "./routes/teacherLessonRouter";

/** ---------- Routes ---------- */
const routes = [
  {
    path: "/login",
    component: Login,
    meta: { hideLayout: true, title: "auth.login" },
  },

  {
    path: "/admin/dashboard",
    component: () => import("@/views/dashboards/AdminDashboard.vue"),
    meta: { 
      requiresAuth: true, 
requiredRoles: ["super_admin", "school_admin"],      title: "dashboard.adminTitle" 
    },
  },
  {
    path: "/academic/dashboard",
    component: () => import("@/views/dashboards/AcademicDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "academic_manager", 
      title: "dashboard.academicTitle", 
      permission: "academic_dashboard.display",
    },
  },
  
  {
    path: "/student-affairs/dashboard",
    component: () => import("@/views/dashboards/StudentAffairsDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "student_affairs", 
      title: "dashboard.studentAffairsTitle", 
      permission: "student_affairs_dashboard.display",
    },
  },
  {
    path: "/teacher/dashboard",
    component: () => import("@/views/dashboards/TeacherDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "teacher", 
      title: "dashboard.teacherTitle" 
    },
  },
  {
    path: "/student/dashboard",
    component: () => import("@/views/dashboards/StudentDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "student", 
      title: "dashboard.studentTitle" 
    },
  },
  {
    path: "/guardian/dashboard",
    component: () => import("@/views/dashboards/GuardianDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "guardian", 
      title: "dashboard.guardianTitle" 
    },
  },
  {
    path: "/finance/dashboard",
    component: () => import("@/views/dashboards/FinanceDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "finance", 
      title: "dashboard.financeTitle" 
    },
  },
  {
    path: "/canteen/dashboard",
    component: () => import("@/views/dashboards/CanteenDashboard.vue"),
    meta: { 
      requiresAuth: true, 
      requiredRole: "canteen", 
      title: "dashboard.canteenTitle" 
    },
  },
  {
  path: "/login",
  name: "login",
  component: () => import("../views/LoginView.vue"),
  meta: { hideLayout: true, title: "auth.login" },
},
  {
  path: "/privacy",
  name: "legal.privacy",
  component: () => import("@/views/legal/PrivacyView.vue"),
  meta: { hideLayout: true, title: "legal.privacyTitle" },
},
{
  path: "/terms",
  name: "legal.terms",
  component: () => import("@/views/legal/TermsView.vue"),
  meta: { hideLayout: true, title: "legal.termsTitle" },
},
{
  path: "/contact",
  name: "legal.contact",
  component: () => import("@/views/legal/ContactView.vue"),
  meta: { hideLayout: true, title: "legal.contactTitle" },
},

  {
    path: "/unauthorized",
    component: () => import("@/views/dashboards/UnauthorizedView.vue"),
    meta: { requiresAuth: true, title: "dashboard.unauthorizedTitle" },
  },
  {
    path: "/subscription-required",
    name: "subscription.required",
    component: () => import("@/views/SubscriptionRequired.vue"),
    meta: { requiresAuth: true, hideLayout: true, title: "subscription.lockedTitle" },
  },
  {
    path: "/my-subscription",
    name: "subscription.my",
    component: () => import("@/views/MySubscription.vue"),
    meta: { requiresAuth: true, title: "subscription.myTitle" },
  },
  {
    path: "/messages",
    name: "messages",
    component: () => import("@/views/chat/MessagesView.vue"),
    meta: { requiresAuth: true, title: "chat.messages" },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/components/profile/ProfilePage.vue'),
    meta: {
      requiresAuth: true,
      title: 'profile.myProfile'
    }
  },
  {
    path: '/profile/edit',
    name: 'profile.edit',
    component: () => import('@/components/profile/ProfileEdit.vue'),
    meta: {
      requiresAuth: true,
      title: 'profile.editProfile'
    }
  },

  ...classRoutes,
  ...groupRoutes,
  ...studentRoutes,
  ...teacherRouter,
  ...userRouter,
  ...guardianRouter,
  ...subjectRouter,
  ...chapterRouter,
  ...chapterSubjectRouter,
  ...assignmentsRouter,
  ...questions,
  ...announcement,
  ...gradeSheetRouter,
  ...paymentRouter,
  ...financialSettings,
  ...reportsRouter,
  ...canteen,
  ...examTypes,
  ...nationalities,
  ...busesRoutes,
  ...areasRoutes,
  ...salaryRoutes,
  ...postsRoutes,
  ...promotionRoutes,
  ...studentRewardsRoutes,
  ...tenantsRoutes,
  ...employeeRouter,
  ...jobTitleRouter,
  ...teacherLessonRouter,


  {
    path: "/",
    redirect: () => {
      const role = getCurrentRole();
      if (!role) return "/login";
      return firstAllowedPath(role);
    },
  },

  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/NotFound.vue"),
    meta: { title: "dashboard.notFoundTitle" },
  },
];

/** ---------- Router ---------- */
const router = createRouter({
  history: createWebHistory(),
  routes,
});

/** ---------- Helpers ---------- */
function setTitle(to) {
  if (!to?.meta?.title) return;
  const appName = i18n.global.t("dashboard.systemName");
  const page = i18n.global.t(to.meta.title);
  document.title = `${page} | ${appName}`;
}

function hasPermissionMeta(to) {
  return to.meta?.permission || to.meta?.permissionAll;
}

function checkPermissionGuard(to) {
  const can = store.getters?.can;
  const canAny = store.getters?.canAny;
  const canAll = store.getters?.canAll;

  if (to.meta?.permission) {
    const req = to.meta.permission;
    if (Array.isArray(req)) return canAny?.(req) === true;
    return can?.(req) === true;
  }

  if (to.meta?.permissionAll) {
    const reqAll = to.meta.permissionAll;
    if (Array.isArray(reqAll)) return canAll?.(reqAll) === true;
    return false;
  }

  return true;
}

function firstAllowedPath(role) {
  const can = store.getters?.can;

  const CANDIDATES = {
    super_admin: [
  { path: "/admin/dashboard" },
  { path: "/statistics", perm: "statistics.display" },
  { path: "/tenants" },
  { path: "/users" },
  { path: "/classes" },
],
    school_admin: [
      { path: "/statistics", perm: "statistics.display" },
      { path: "/admin/dashboard" },
      { path: "/users" },
      { path: "/classes" },
    ],

    academic_manager: [
      { path: "/academic/dashboard", perm: "academic_dashboard.display" },
      { path: "/classes",           perm: "classes.display" },
      { path: "/teachers",          perm: "teachers.display" },
      { path: "/subjects",          perm: "subjects.display" },
      { path: "/grade-sheets",      perm: "grade_sheets.display" },
      { path: "/announcements",     perm: "announcements.display" },
    ],

    student_affairs: [
      { path: "/student-affairs/dashboard", perm: "student_affairs_dashboard.display" },
      { path: "/classes",                   perm: "classes.display" },
      { path: "/students",                  perm: "students.display" },
      { path: "/guardians",                 perm: "guardians.display" },
      { path: "/announcements",             perm: "announcements.display" },
      { path: "/attendances",               perm: "student_attendance.display" },
    ],

    finance: [
      { path: "/class-fees",           perm: "class_fees.display" },
      { path: "/financial-settings",   perm: "financial_settings.display" },
      { path: "/financial-statements", perm: "financial_statements.display" },
      { path: "/payment-receipts",     perm: "payment_receipts.display" },
      { path: "/finance/dashboard" },
    ],

    canteen: [
      { path: "/canteen",          perm: "canteen_transactions.display" },
      { path: "/canteen/products", perm: "canteen_products.display" },
      { path: "/canteen/dashboard" },
    ],

    teacher: [
      { path: "/teacher/dashboard" },
      { path: "/assignments" },
      { path: "/exams" },
      { path: "/attendances" },
      { path: "/grade-sheets" },
    ],
    
    student: [
      { path: "/student/dashboard" },
      { path: "/student-schedule" },
      { path: "/student/assignments" },
      { path: "/student/attendances" },
      { path: "/student/grades" },
    ],
    
    guardian: [
      { path: "/guardian/dashboard" },
      { path: "/attendances" },
    ],
  };

  const list = CANDIDATES[role] || [];
  for (const item of list) {
    if (!item.perm || can?.(item.perm) === true) return item.path;
  }
  return "/unauthorized";
}

/** ---------- Global Guard ---------- */
function getCurrentRole() {
  return store.state?.user?.role?.slug || Cookies.get("user_type") || null;
}



router.beforeEach(async (to, from, next) => {
  setTitle(to);

  const token = Cookies.get("token") || store.state.token;
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
const requiredRole = to.meta?.requiredRole;
const requiredRoles = to.meta?.requiredRoles;

  // Public route
  if (!requiresAuth) return next();

  // Require auth
  if (!token) {
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  // Ensure user loaded (after hard refresh)
  try {
    if (!store.state.user) {
      await store.dispatch("fetchCurrentUser");
    }
  } catch {
    // token invalid or fetch failed -> force login
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  // Ensure permissions loaded
  try {
    if (!store.state.permissionsReady) {
      await store.dispatch("loadMyPermissions");
      store.commit("SET_PERMISSIONS_READY", true);
    }
  } catch {
    // ignore; server-side will still 403 if needed
  }

const role = getCurrentRole();

if (role === "super_admin") {
  return next();
}

if (requiredRole && role !== requiredRole) {
  console.warn(`Unauthorized: user is '${role}' but route needs '${requiredRole}'`);
  return next("/unauthorized");
}

if (requiredRoles && !requiredRoles.includes(role)) {
  console.warn(`Unauthorized: user is '${role}' but route needs one of '${requiredRoles.join(", ")}'`);
  return next("/unauthorized");
}

  if (hasPermissionMeta(to)) {
    const ok = checkPermissionGuard(to);
    if (!ok) {
      const role = getCurrentRole();
      if (role && DASHBOARD_BY_ROLE[role]) {
        return next(firstAllowedPath(role));
      }
      return next("/unauthorized");
    }
  }

  return next();
});

const DASHBOARD_BY_ROLE = {
  school_admin: "/admin/dashboard",
  academic_manager: "/academic/dashboard",
  student_affairs: "/student-affairs/dashboard",
  teacher: "/teacher/dashboard",
  student: "/student/dashboard",
  guardian: "/guardian/dashboard",
  finance: "/finance/dashboard",
  canteen: "/canteen/dashboard",
};

export default router;